<template>
    <div>
        <router-view></router-view>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { SET_SYSTEM_PARAMS, SET_IS_RESELLER } from '@store/_mutations'
export default {
    methods: {
        ...mapMutations({
            setSystemParams: SET_SYSTEM_PARAMS,
            setIsReseller: SET_IS_RESELLER,
        }),
        async loadSystemParams() {
            const { data } = await this.$repo.get('system-params', {
                scope: 'front',
            })
            this.setSystemParams(data)
        },
        async checkDomain() {
            // Temp para pruebas

            const domain = window.location.hostname
            const isReseller = !['localhost', 'app', 'staging', 'testing'].some((item) => domain.includes(item))
            this.clientChecked = true
            if (!isReseller) return
            this.setIsReseller(isReseller)
            const { data: client } = await this.$repo.get(`domains/${domain}/clients`)
            !!client && this.setCurrentClient(client)
        },
    },
    created() {
        this.checkDomain()
        this.loadSystemParams()
    },
}
</script>
